(function (root, factory) {
  const api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (root) root.VendeyCotizaciones = api;
})(typeof window !== "undefined" ? window : globalThis, function () {
  "use strict";

  const STORAGE_KEY = "vendeyCotizacionesLocalesV1";
  const STORAGE_TEMPLATE_KEY = "vendeyPlantillaCotizacionV1";
  const MAX_COTIZACIONES = 150;
  const URL_VENDEY_PRO =
    "https://play.google.com/store/apps/details?id=vendeypro.cenfelec.com&pcampaignid=web_share";
  const URL_CENFEBOT =
    "https://wa.me/51924193306?text=Hola%20quiero%20cotizar";
  const PLANTILLA_DEFAULT = Object.freeze({
    empresa: "VENDEY PRO",
    slogan: "Soluciones para hacer crecer tu negocio",
    rucEmpresa: "",
    direccionEmpresa: "",
    telefonoEmpresa: "",
    correoEmpresa: "",
    titulo: "COTIZACIÓN",
    subtitulo: "Propuesta comercial",
    vigenciaDias: 7,
    formaPago: "Por coordinar",
    formaEntrega: "Recojo o envío coordinado",
    tiempoEntrega: "Por coordinar",
    condiciones: "Precios sujetos a disponibilidad y confirmación.",
    terminos: "La cotización está sujeta a disponibilidad de stock. Los precios y condiciones son válidos durante el plazo indicado.",
    cuentasBancarias: "",
    impuestos: "Precios incluyen los impuestos aplicables, salvo indicación distinta.",
    pie: "Gracias por confiar en nosotros.",
    color: "#167544",
    logoAnchoMm: 29,
    logoDataUrl: ""
  });

  function texto(value) {
    return String(value == null ? "" : value).trim();
  }

  function numero(value) {
    const parsed = Number(String(value == null ? "" : value).replace(",", "."));
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function dinero(value) {
    return numero(value).toFixed(2);
  }

  function idCotizacion(fecha) {
    const iso = fecha.toISOString().replace(/\D/g, "").slice(0, 14);
    const aleatorio = Math.random().toString(36).slice(2, 7).toUpperCase();
    return `COT-${iso}-${aleatorio}`;
  }

  function normalizarItem(item) {
    const cantidad = Math.max(0, numero(item?.cantidad));
    const precio = Math.max(0, numero(item?.precio));
    const totalInformado = Math.max(0, numero(item?.total));
    return {
      codigo: texto(item?.codigo),
      descripcion: texto(item?.descripcion) || "Producto",
      cantidad,
      precio,
      total: totalInformado || cantidad * precio
    };
  }

  function normalizarPlantilla(plantilla) {
    const color = texto(plantilla?.color);
    const logo = texto(plantilla?.logoDataUrl);
    return {
      empresa: texto(plantilla?.empresa).slice(0, 100) || PLANTILLA_DEFAULT.empresa,
      slogan: texto(plantilla?.slogan).slice(0, 160) || PLANTILLA_DEFAULT.slogan,
      rucEmpresa: texto(plantilla?.rucEmpresa).slice(0, 30),
      direccionEmpresa: texto(plantilla?.direccionEmpresa).slice(0, 240),
      telefonoEmpresa: texto(plantilla?.telefonoEmpresa).slice(0, 60),
      correoEmpresa: texto(plantilla?.correoEmpresa).slice(0, 100),
      titulo: texto(plantilla?.titulo).slice(0, 60) || PLANTILLA_DEFAULT.titulo,
      subtitulo: texto(plantilla?.subtitulo).slice(0, 100) || PLANTILLA_DEFAULT.subtitulo,
      vigenciaDias: Math.min(365, Math.max(1, Math.round(numero(plantilla?.vigenciaDias) || PLANTILLA_DEFAULT.vigenciaDias))),
      formaPago: texto(plantilla?.formaPago).slice(0, 180) || PLANTILLA_DEFAULT.formaPago,
      formaEntrega: texto(plantilla?.formaEntrega).slice(0, 180) || PLANTILLA_DEFAULT.formaEntrega,
      tiempoEntrega: texto(plantilla?.tiempoEntrega).slice(0, 180) || PLANTILLA_DEFAULT.tiempoEntrega,
      condiciones: texto(plantilla?.condiciones).slice(0, 500) || PLANTILLA_DEFAULT.condiciones,
      terminos: texto(plantilla?.terminos).slice(0, 1600) || PLANTILLA_DEFAULT.terminos,
      cuentasBancarias: texto(plantilla?.cuentasBancarias).slice(0, 1200),
      impuestos: texto(plantilla?.impuestos).slice(0, 300) || PLANTILLA_DEFAULT.impuestos,
      pie: texto(plantilla?.pie).slice(0, 300) || PLANTILLA_DEFAULT.pie,
      color: /^#[0-9a-f]{6}$/i.test(color) ? color : PLANTILLA_DEFAULT.color,
      logoAnchoMm: Math.min(
        55,
        Math.max(16, Math.round(numero(plantilla?.logoAnchoMm) || PLANTILLA_DEFAULT.logoAnchoMm))
      ),
      logoDataUrl: /^data:image\/(png|jpe?g|webp);base64,/i.test(logo) ? logo : ""
    };
  }

  function obtenerPlantilla(storage) {
    try {
      return normalizarPlantilla(JSON.parse(
        storage?.getItem(STORAGE_TEMPLATE_KEY) || "{}"
      ));
    } catch (_) {
      return normalizarPlantilla({});
    }
  }

  function guardarPlantilla(plantilla, storage) {
    if (!storage || typeof storage.setItem !== "function") {
      throw new Error("No se encontró almacenamiento local disponible.");
    }
    const normalizada = normalizarPlantilla(plantilla);
    storage.setItem(STORAGE_TEMPLATE_KEY, JSON.stringify(normalizada));
    return normalizada;
  }

  function normalizarCotizacion(datos) {
    const fecha = datos?.fecha ? new Date(datos.fecha) : new Date();
    const fechaValida = Number.isNaN(fecha.getTime()) ? new Date() : fecha;
    const items = Array.from(datos?.items || [])
      .map(normalizarItem)
      .filter(item => item.cantidad > 0 && item.descripcion);
    const totalItems = items.reduce((acumulado, item) => acumulado + item.total, 0);
    const id = texto(datos?.id) || idCotizacion(fechaValida);
    return {
      id,
      numero: texto(datos?.numero) || id,
      fecha: fechaValida.toISOString(),
      cliente: texto(datos?.cliente) || "CLIENTE VARIOS",
      documento: texto(datos?.documento),
      direccion: texto(datos?.direccion),
      telefono: texto(datos?.telefono),
      empresa: texto(datos?.empresa),
      almacen: texto(datos?.almacen),
      vendedor: texto(datos?.vendedor),
      moneda: "PEN",
      items,
      total: numero(datos?.total) || totalItems,
      plantilla: normalizarPlantilla(datos?.plantilla),
      estado: "LOCAL",
      afectaCaja: false
    };
  }

  function leer(storage) {
    try {
      const resultado = JSON.parse(storage?.getItem(STORAGE_KEY) || "[]");
      return Array.isArray(resultado)
        ? resultado.map(normalizarCotizacion).sort((a, b) => b.fecha.localeCompare(a.fecha))
        : [];
    } catch (_) {
      return [];
    }
  }

  function guardar(datos, storage) {
    if (!storage || typeof storage.setItem !== "function") {
      throw new Error("No se encontró almacenamiento local disponible.");
    }
    const cotizacion = normalizarCotizacion(datos);
    if (!cotizacion.items.length) {
      throw new Error("Agrega al menos un producto antes de guardar la cotización.");
    }
    const existentes = leer(storage).filter(item => item.id !== cotizacion.id);
    storage.setItem(
      STORAGE_KEY,
      JSON.stringify([cotizacion, ...existentes].slice(0, MAX_COTIZACIONES))
    );
    return cotizacion;
  }

  function eliminar(id, storage) {
    if (!storage || typeof storage.setItem !== "function") return false;
    const existentes = leer(storage);
    const filtradas = existentes.filter(item => item.id !== texto(id));
    if (filtradas.length === existentes.length) return false;
    storage.setItem(STORAGE_KEY, JSON.stringify(filtradas));
    return true;
  }

  function fechaPeru(fecha) {
    return new Intl.DateTimeFormat("es-PE", {
      timeZone: "America/Lima",
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(fecha));
  }

  function textoParaWhatsApp(datos, plantillaActiva) {
    const cotizacion = normalizarCotizacion(datos);
    const plantilla = normalizarPlantilla(
      plantillaActiva || cotizacion.plantilla
    );
    const lineas = [
      `*${plantilla.empresa} · ${plantilla.titulo}*`,
      plantilla.subtitulo,
      `N.° ${cotizacion.numero}`,
      `Fecha: ${fechaPeru(cotizacion.fecha)}`,
      "No es comprobante y no afecta caja.",
      "",
      `Cliente: ${cotizacion.cliente}`
    ];
    if (cotizacion.documento) lineas.push(`Documento: ${cotizacion.documento}`);
    if (cotizacion.direccion) lineas.push(`Dirección: ${cotizacion.direccion}`);
    lineas.push("", "*Detalle:*");
    cotizacion.items.forEach((item, indice) => {
      lineas.push(
        `${indice + 1}. ${item.descripcion} · ${item.cantidad} x S/ ${dinero(item.precio)} = S/ ${dinero(item.total)}`
      );
    });
    lineas.push("", `*TOTAL COTIZADO: S/ ${dinero(cotizacion.total)}*`);
    lineas.push(
      `Vigencia: ${plantilla.vigenciaDias} días`,
      `Forma de pago: ${plantilla.formaPago}`,
      `Entrega: ${plantilla.formaEntrega}`,
      plantilla.condiciones
    );
    if (plantilla.cuentasBancarias) {
      lineas.push("", "*Cuentas bancarias:*", plantilla.cuentasBancarias);
    }
    lineas.push("", "*Términos y condiciones:*", plantilla.terminos);
    if (plantilla.pie) lineas.push(plantilla.pie);
    lineas.push(
      "",
      `🤖 Crea cotizaciones con CenfeBot: ${URL_CENFEBOT}`,
      `📱 Cotización generada por Vendey Pro: ${URL_VENDEY_PRO}`
    );
    return lineas.join("\n");
  }

  function capturarDesdePos(documento, storage) {
    const doc = documento || (typeof document !== "undefined" ? document : null);
    if (!doc) throw new Error("No se pudo leer el punto de venta.");
    const items = Array.from(doc.querySelectorAll("#tbodyproductos .countable")).map(celda => ({
      codigo: celda.getAttribute("ncodproducto"),
      descripcion: celda.getAttribute("cproductodesc"),
      cantidad: celda.getAttribute("ncantidad"),
      precio: celda.getAttribute("nprecio"),
      total: celda.getAttribute("ntotal")
    }));
    const valor = id => texto(doc.getElementById(id)?.value);
    const contenido = id => texto(doc.getElementById(id)?.textContent);
    const ls = storage || (typeof localStorage !== "undefined" ? localStorage : null);
    return normalizarCotizacion({
      cliente: valor("txtrazonsocial"),
      documento: valor("txtNumeroDni"),
      direccion: valor("txtdireccioncliente"),
      telefono: valor("txttelefonocliente"),
      empresa: ls?.getItem("gsempresaglobal") || "",
      almacen: ls?.getItem("nombrealmacen") || ls?.getItem("gsalmacen") || "",
      vendedor: ls?.getItem("nombrevendedor") || "",
      total: contenido("txttotalventa"),
      plantilla: obtenerPlantilla(ls),
      items
    });
  }

  return {
    STORAGE_KEY,
    STORAGE_TEMPLATE_KEY,
    MAX_COTIZACIONES,
    URL_VENDEY_PRO,
    URL_CENFEBOT,
    PLANTILLA_DEFAULT,
    normalizarPlantilla,
    obtenerPlantilla,
    guardarPlantilla,
    normalizarCotizacion,
    guardar,
    listar: leer,
    eliminar,
    textoParaWhatsApp,
    capturarDesdePos,
    fechaPeru,
    dinero
  };
});
